import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("tab-button", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-tab-button/>`);
        const el = await page.find("ux-tab-button");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-tab-button name="Tab 1" active-tab="tab1" tab-id="tab1" />`
        );
        const el = await page.find("ux-tab-button");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
        expect(el.classList.contains("is-active")).toBe(true);
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-tab-button name="Tab 1" active-tab="tab1" tab-id="tab1" />`
        );
    });
});
